import { toast } from 'react-toastify';

export const notify = ($msg: string, position: string = 'bottom-right') =>
  toast($msg, {
    position: position,
    autoClose: 5000,
    hideProgressBar: true,
    closeOnClick: true,
    pauseOnHover: false,
    draggable: true,
    progress: undefined,
  });

export const notifySuccess = ($msg: string) =>
  toast.success($msg, {
    position: 'bottom-right',
    autoClose: 5000,
    hideProgressBar: true,
    closeOnClick: true,
    pauseOnHover: false,
    draggable: true,
    progress: undefined,
    // style: {
    //   backgroundColor: "#17a444",
    //   color: "white",
    // },
  });

export const notifyError = ($msg: string) =>
  toast.error($msg, {
    position: 'bottom-right',
    autoClose: 5000,
    hideProgressBar: true,
    closeOnClick: true,
    pauseOnHover: false,
    draggable: true,
    progress: undefined,
    style: {
      backgroundColor: '#a41717',
      color: 'white',
    },
  });
